import React from 'react'
import moment from 'moment'
import { Badge } from '@/components/ui/badge'

class NavbarSearchResultResource extends React.Component {

  constructor(props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  onClick(e) {
    e.stopPropagation()
    this.props.onClick(this.props.resource)
  }

  render() {
    const resource = this.props.resource

    return (
      <Badge
        variant="secondary"
        className="cursor-pointer font-semibold hover:bg-[color-mix(in_oklab,var(--secondary),var(--secondary-foreground)_8%)]"
        title={moment(resource.created_at).format('YYYY-MM-DD HH:mm')}
        onClick={this.onClick}
      >
        {resource.type} {resource.id}
      </Badge>
    )
  }
}

export default NavbarSearchResultResource
